/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import Message, { IMessage } from './../../../message';
import { IDescriptorBody } from '../../../descriptor';

export interface IResolveCommentThreadResponse extends IMessage {
	commentThreadId: string;
	documentId: string;
	resolvedBy: string;
	resolvedAt: string;
}

export default class ResolveCommentThreadResponse extends Message {
	public readonly resolvedAt: Date;

	public static readonly DESCRIPTOR_NAME: string = 'CommentsV2ResolveCommentThreadResponse';

	public static readonly DESCRIPTOR: IDescriptorBody = {
		fields: {
			commentThreadId: {
				type: 'string',
				id: 1
			},
			documentId: {
				type: 'string',
				id: 2
			},
			resolvedAt: {
				type: 'string',
				id: 3
			},
			resolvedBy: {
				type: 'string',
				id: 4
			}
		}
	};

	public constructor(
		public readonly commentThreadId: string,
		public readonly documentId: string,
		public readonly resolvedBy: string,
		resolvedAt: string
	) {
		super();

		this.resolvedAt = new Date( resolvedAt );
	}

	public toJSON(): IResolveCommentThreadResponse {
		return {
			commentThreadId: this.commentThreadId,
			documentId: this.documentId,
			resolvedBy: this.resolvedBy,
			resolvedAt: this.resolvedAt.toISOString()
		};
	}

	public static fromJSON( data: IResolveCommentThreadResponse ): ResolveCommentThreadResponse {
		return new ResolveCommentThreadResponse( data.commentThreadId, data.documentId, data.resolvedBy, data.resolvedAt );
	}
}
